module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("List of Illustrations")]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("1.")]), _vm._v(" Epitaph of Marcus Caelius, victim of the Battle of the Teutoburg Forest. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Agnete, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("2.")]), _vm._v(" Achaemenid Persian Fort, Tall-e Takht, Pasargadae, Iran. The Persians had an extensive fortification network which includes sites like this, part of the Pasargadae World Heritage Site. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Diego Delso, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("3.")]), _vm._v(" The Battle of Cunaxa fought between the Persians and 10,000 Greek mercenaries of Cyrus the Young, 401 bce, Adrien Guiget, Louvre. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("4.")]), _vm._v(" Hoplite from Dodona Antikensammlung Berlin Misc. 7470. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("5.")]), _vm._v(" The Army of Artaxerxes II on the Tomb of Artaxerxes, Persepolis. The units (ethnic groups) depicted on the top of the frieze, from left to right, are Persian, Median, Elamite, Parthian, Arian, Bactrian, Sogdian, Choresmian, Zarangian, Arachosian, Sattagydian, Gandharan, Hindush, and haumavarga Saka. On the bottom, from left to right, are Makan, tigraxauda Saka, Babylonian, Assyrian, Arab, Egyptian, Armenian, Cappadocian, Lydian, Ionian, overseas Saka, Skudrian, Ionian with shield-hat, Libyan, Ethiopian, and Carian. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Adobe Stock")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("6.")]), _vm._v(" Battle of Chaeronea, nineteenth century. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("7.")]), _vm._v(" The Battlefield of Issus. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("8.")]), _vm._v(" The location of Issus. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Google Earth Pro")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu2"
  }, [_vm._v("9.")]), _vm._v(" Aerial view of Issus. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Google Earth Pro")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("10.")]), _vm._v(" Alexander’s potential view. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Google Earth Pro")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("11.")]), _vm._v(" The Alexander Mosaic, from the House of the Faun in Pompeii, Naples Archaeological Museum. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Carole Raddato, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("12.")]), _vm._v(" Carthaginian Shekel. The Carthaginians under Hannibal famously marched across the Alps with elephants. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("13.")]), _vm._v(" Map of area around Cannae. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Google Earth Pro")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("14.")]), _vm._v(" The modern monument at Cannae. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("15.")]), _vm._v(" Pydna Relief, Monument of Aemilius Paulus. This is our earliest image of a Roman soldier, in sculptural relief, from the middle of the second century bce. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Colin Whiting, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("16.")]), _vm._v(" The walls of New Carthage (Cartagena), Spain. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("17.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Quadriga")]), _vm._v(", Arch of Titus, Rome. Part of the triumphal parade depicted on the column in sculptural relief. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Salko, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("18.")]), _vm._v(" Aerial view of Masada. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("19.")]), _vm._v(" The Roman Camp F at Masada. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Aren Rozen, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("20.")]), _vm._v(" The Roman ramp at Masada. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright G Solomon, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("21.")]), _vm._v(" The Cave of Letters. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright, Israel Antiquities Authority, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("22.")]), _vm._v(" The Black Gate, Trier. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Conor Whately")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("23.")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Testudo")]), _vm._v(", Trajan’s Column. Though much earlier in date, this is the most famous Roman depiction of a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("testudo")]), _vm._v(" that we have. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Christian Chirita, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("24.")]), _vm._v(" The Roman barracks at el-Lejjūn, Jordan. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Conor Whately")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("25.")]), _vm._v(" A view of the Rhine from Mainz, Germany. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Conor Whately")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("26.")]), _vm._v(" The Seizure of Edessa, 1071, in the Chronicle of John Skylitzes. This medieval manuscript illustrates a later siege of that same city. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("27.")]), _vm._v(" Urfa Castle, Urfa/Edessa, Turkey. Some of the most famous extant ruins from Edessa (modern Urfa) are those depicted here, of Abbasid-era Urfa Castle. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Barnard Gagnon, Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("28.")]), _vm._v(" The walls at Diyarbakir, Turkey. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("29.")]), _vm._v(" The possible fortification view from Edessa. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Google Earth Pro")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("30.")]), _vm._v(" The siege mound at Dura Europos. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("31.")]), _vm._v(" The range of visibility of the smoke from Edessa. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Google Earth Pro")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "illu1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Plates#fig32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "illu3"
  }, [_vm._v("32.")]), _vm._v(" Abgar of Edessa receiving the Mandylion from Thaddeus, from Saint Catherine’s Monastery, Egypt. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Copyright Wikimedia Commons")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32d4e652","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Listofillustrations.vue
// module id = 72
// module chunks = 0